
  import { defineComponent } from 'vue';
  import SearchComponent from '../SearchComponent.vue';

  export default defineComponent({
    name: 'HeroSection',
    components: { SearchComponent },
  });
